import {BaseEffect} from './base.effect';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {SendBackResult} from '../models/send-back-result';
import {ArrayResponse} from '../models/array-response';
import {Router} from '@angular/router';
import {debug} from '../../../rxjs-operators';
import {catchError, map, switchMap} from 'rxjs/operators';
import {error} from '..';
import {L10nTranslationService} from 'angular-l10n';
import {LicencesService} from '../services/licences.service';
import {billingLicencesActionTypes, LoadBillingLicencesFailAction, LoadBillingLicencesSuccessAction} from '../actions/licences';

@Injectable()
export class LicencesEffect extends BaseEffect {


  load$ = createEffect(() => { return this.actions$.pipe(
    ofType(billingLicencesActionTypes.LOAD),
    debug('Products load action received.'),
    switchMap(() => this.licencesService.getList().pipe(
      // tslint:disable-next-line:no-any
      map((payload: SendBackResult<ArrayResponse<any>>) => new LoadBillingLicencesSuccessAction(payload.data.array)),
      catchError(res => this.catchResponseError(res)),
    )),
  ) });

  loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(billingLicencesActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving products list.'),
    map((action: LoadBillingLicencesFailAction) =>
      error(this.translation.translate('PRODUCTS_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE')))
  ) });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private licencesService: LicencesService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadBillingLicencesFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadBillingLicencesFailAction(response['error'].message);
  }
}
